var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBox = function SvgCheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "check-box_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.6 16.2 7.05-7.05-1.4-1.4-5.65 5.65-2.85-2.85-1.4 1.4zM3 21V3h18v18zm2-2h14V5H5zm0 0V5z"
  })));
};
export { SvgCheckBox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTAuNiAxNi4yTDE3LjY1IDkuMTQ5OTlMMTYuMjUgNy43NUwxMC42IDEzLjRMNy43NSAxMC41NUw2LjM1IDExLjk1TDEwLjYgMTYuMlpNMyAyMVYzSDIxVjIxSDNaTTUgMTlIMTlWNUg1VjE5Wk01IDE5VjVWMTlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";